import React from 'react';
import classes from "./style.module.scss";

const ProductInformation = ({ productData }) => {
    return (
        <div className={`${classes.productCardWrapper} mb-4`}>
            <div className={`${classes.detailsWrapper}`}>
                <div className='flex items-center mb-3'>
                    <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20`}>
                        General Info
                    </div>
                </div>
                <div className={`${classes.infoWrapper}`}>
                    {productData.map((info, index) => (
                        <div key={index} className={`${classes.inforCategory}`}>
                            <div className={`${classes.infoLabel}`}>{info.label}</div>
                            <div className={`${classes.infoValue} ${classes.highlight}`}>{info.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductInformation;
